// W-12's words (`mockups/web/w12-welcome.html`; REQ-002 AC1 at REQUIREMENTS v2.9, T-381 (g) / D-1127 (g)).
//
// **Why a table, and why not a catalogue key.** These are APP COPY — the welcome screen's own labels, like
// T-428's four sibling sentences (D-1127 (j)): nothing on the wire parameterises them, no server sends them,
// and `packages/core`'s message catalogue is for the sentences a SERVER picks. So they live in each build's
// own table and SC-2 holds them to the same characters: `apps/mobile/src/screens/WelcomeScreen.copy.ts` takes
// these three strings verbatim and `WelcomeScreen.parity.test.ts` reads this file as text to prove it.
//
// **What the three are for.** On a build that already HOLDS an account (an API build — `AppConfig.apiBuild`),
// "Try the demo" was the screen's ONLY call to action and the way back to the real account was `?server=api`
// or clearing `sl.server` by hand — a one-way door the T-210 lane deliberately did not close with invented
// words (D-1095 (g)). REQ-002 AC1 closes it with the product's: the primary action opens the account the build
// already has, under one supporting line that says what it will and will not do, and "Try the demo" steps down
// to secondary (DS §12 row 1: one primary per view). A build with NO account configured is unchanged.
//
// This is NOT REQ-003's "Connect your own ad account", which needs Meta's consent screen and stays V1 — the
// account is already configured, so the press runs exactly the code the mode switch runs and crosses no gate.

export const WELCOME_COPY = {
  /** The demo's call to action. Primary on a demo build, secondary on a build that has an account. */
  tryTheDemo: 'Try the demo',
  /** The primary action on a build that HAS an account — it opens the one the build already holds. */
  openMyAdAccount: 'Open my ad account',
  /** The single supporting line under it: what it is, and the limit, in five words. */
  openMyAdAccountNote: 'Your real numbers, view-only.',
} as const;
